import { environment } from "./config";
export const configuration = environment;